import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardMapViewComponent } from './dashboard-map-view/dashboard-map-view.component';
import { DashboardTableViewComponent } from './dashboard-table-view/dashboard-table-view.component';
import { DashboardCardViewComponent } from './dashboard-card-view/dashboard-card-view.component';
import { DeviceContextMenuComponent } from './device-context-menu/device-context-menu.component';
import { TableModule } from 'primeng/table';
import { CoreModule } from '@app/core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { TabViewModule } from 'primeng/tabview';
import { SliderModule } from 'primeng/slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule } from "primeng/calendar";
import { SharedModule } from '../shared/shared.module';
import { QdsButton, QdsChip, QdsInput, QdsMenuItem, QdsTitle, QdsIcon, QdsListItem, QdsLabel, QdsDialog, BooleanValueAccessor, QdsTooltip, QdsLoader, QdsFormMessage } from '@quartzds/core-angular';
import { AccordionModule } from 'primeng/accordion';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardService } from './dashboard.service';


@NgModule({
  imports: [
    CommonModule, NgbModule,
    QdsButton, QdsTitle, QdsInput, QdsChip, QdsMenuItem, QdsIcon, QdsLabel, QdsDialog,
    DashboardRoutingModule,
    BrowserModule,
    BrowserAnimationsModule, // <-- Add this to imports
    AccordionModule, // <--
    CoreModule,
    FormsModule,
    QdsListItem,
    BooleanValueAccessor,
    QdsTooltip,
    QdsLoader,
    QdsFormMessage,
    TranslateModule,
],
  declarations: [
    DashboardComponent,
    DashboardMapViewComponent,
    DashboardTableViewComponent,
    DashboardCardViewComponent,
    DeviceContextMenuComponent
  ],
  providers: [DashboardService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule { }
